import React from 'react';

const VisionSection = ({ data }) => {
  return (
    <section id="vision" className="vision-section">
      <div className="section-container">
        <div className="vision-content">
          <div className="section-label">My Vision</div>
          <h2 className="section-heading-center">{data.title}</h2>
          <p className="vision-subtitle">{data.subtitle}</p>
          
          <div className="vision-statement-box">
            <p className="vision-statement">
              {data.statement}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisionSection;
